import React from 'react';
import {Col, Row, Upload} from 'antd';
import {DownloadOutlined, UploadOutlined} from '@ant-design/icons';
import Button from '../../components/data_entry/Button';
import Form from '../../components/data_entry/form/Form';
import {FIELD_NAMES} from './constants';

export default function DocumentsSection({siteSettings, uploadProps, normFile}) {
    return (
        <Row>
            <Col xs={24} sm={12}>
                {siteSettings?.judicial_term_pdf && (
                    <div style={{marginBottom: 8}}>
                        <a href={siteSettings.judicial_term_pdf}
                           target="_blank"
                           rel="noopener noreferrer">
                            <DownloadOutlined/> Baixar modelo do Termo Judicial
                        </a>
                    </div>
                )}
                <Form.Item
                    label="Termo Judicial (PDF)"
                    name={FIELD_NAMES.JUDICIAL_TERM_PDF}
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[{required:true, message: 'Campo obrigatório' }]}
                >
                    <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined/>}>Selecionar arquivo</Button>
                    </Upload>
                </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
                {siteSettings?.consent_term_pdf && (
                    <div style={{marginBottom: 8}}>
                        <a href={siteSettings.consent_term_pdf}
                           target="_blank"
                           rel="noopener noreferrer">
                            <DownloadOutlined/> Baixar modelo do Termo de Consentimento
                        </a>
                    </div>
                )}
                <Form.Item
                    label="Termo de Consentimento (PDF)"
                    name={FIELD_NAMES.CONSENT_TERM_PDF}
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[{required:true, message: 'Campo obrigatório' }]}
                >
                    <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined/>}>Selecionar arquivo</Button>
                    </Upload>
                </Form.Item>
            </Col>
        </Row>
    );
}
